import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import convertDateOverTime from '../../../../helpers/convertDateOverTime'
import {Tag} from 'antd'

function SewingRepairRow(props) {
    const { item, setType, setBrand } = props
    const { batch_id, sewing_repair, product_type} = item
    const { partner, sewing_partner, tags = [], production_meta } = { ...batch_id }
    const { sewing_groups = [] } = { ...production_meta }
    const barcode_number = item.item.marketplace
    const item_number = item.item.item_number
    const brand = item.item.brand
    const barcodeNumber = barcode_number + '_' + item_number
    const overTime = item.item.overtime

    const isGiftTag = Array.isArray(tags) && tags.includes('gift')
    const isSampleTag = Array.isArray(tags) && tags.includes('sample')
    const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
    const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
    const isUIDSAMPLETag = Array.isArray(tags) && tags.includes('UIDSAMPLE')
    const isCutOff = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isTikTok = Array.isArray(tags) && tags.includes('tiktok')
    const is24hTag = Array.isArray(tags) && tags.includes('24h')
    const isSLLTag = Array.isArray(tags) && tags.includes('SLL')
    const isComboSock = Array.isArray(tags) && tags.includes('combo_socks')
    
    const onClickType = (value) => {
        setType(value)
    }
    const onClickBrand = (value) => {
        setBrand(value)
    }

    function _detectChecked() {
        const {item, selectedBatchId} = props

        return selectedBatchId.includes(item.item._id)
    }

    function _handleChange() {
        const {item, onUpdateSelectedBatches} = props
        const isChecked = _detectChecked()

        onUpdateSelectedBatches(item.item._id, !isChecked, item.item._id)
    }
    const overtimeText = !!overTime ? convertDateOverTime(overTime) : '-'

    return (
        <tr>
            <td className="BatchSelectedAll">
                <input
                    type="checkbox"
                    checked={_detectChecked()}
                    onChange={_handleChange}
                />
            </td>
            <td>
                <div className="d-flex flex-column">
                    {!!barcode_number &&
                        <Link
                            to={`/order-item?template=${barcodeNumber}`}
                            target='_blank'>
                            #{barcodeNumber}
                        </Link>
                    }
                    {
                        isGiftTag && 
                        <div className='mb-1'><Tag color="#6c757d">Hàng tặng</Tag></div>
                    }

                    {
                        isSampleTag && 
                        <div className='mb-1'><Tag color="#6c757d">Hàng mẫu</Tag></div>
                    }

                    {
                        isFbaTag && 
                        <div className='mb-1'><Tag color="#6c757d">FBA</Tag></div>
                    }

                    {
                        isFastShipTag && 
                        <div className='mb-1'><Tag color="#6c757d">Ship nhanh</Tag></div>
                    }

                    {
                        isUIDSAMPLETag && 
                        <div className='mb-1'><Tag color="#6c757d">UIDSAMPLE</Tag></div>
                    }

                    {
                        isFastProductionTag && 
                        <div className='mb-1'><Tag color="#FFA500">Sản xuất nhanh</Tag></div>
                    }

                    {
                        isTikTok && 
                        <div className='mb-1'><Tag color="#dc3644">TIKTOK</Tag></div>
                    }

                    {
                        is24hTag &&
                        <div className='mb-1'><Tag color="#dc3644">24h</Tag></div>
                    }

                    {
                        isCutOff && 
                        <div><Tag color="#FF6600">cutoff</Tag></div>
                    }

                    {
                        isCutOffNoel &&
                        <div><Tag color="#FF6600">cutoff_noel</Tag></div>
                    }

                    {
                        isCutOffNewYear &&
                        <div><Tag color="#FF6600">cutoff_new_year</Tag></div>
                    }

                    {
                        isSLLTag &&
                        <div><Tag color="#fdb813">SLL</Tag></div>
                    }

                    {
                        isComboSock && 
                        <div>
                            <Tag color="#d334ce">Combo socks</Tag>
                        </div>
                    }
                </div>
            </td>
            <td className='ProductType'>
                {!!product_type &&
                    <span className="mr-2" onClick={() => onClickType([product_type])}>{product_type}</span>
                }
                {!!brand && !!brand.name &&
                    <div className='Brand'>
                        <span className="mr-2" onClick={() => onClickBrand([brand.name])}>{brand.name}</span>
                    </div>
                }
            </td>
            <td>{item.item.size || '-'}</td>
            <td>{moment(sewing_repair.pending_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td>{!!sewing_repair && !!sewing_repair.type ? sewing_repair.type : '-'}</td>
            <td className='OverTime d-flex align-items-center'>
                {overTime > 0 &&
                    <label
                        className='btn btn-sm mr-1 mb-0'
                        style={{
                            background: 'rgb(255 77 80)',
                            color: 'white',
                        }}
                    >
                        Quá hạn
                    </label>
                }
                <span className={`mb-0 ${overTime > 0 ? 'text-danger' : ''}`}>{overtimeText}</span>
            </td>
            <td>{!!partner && !!partner.name ? partner.name : '-'}</td>
            <td>{!!sewing_partner && !!sewing_partner.name ? sewing_partner.name : '-'}</td>
            <td>{sewing_groups.map(i => i.name).join(', ')}</td>
        </tr>
    )
}

export default SewingRepairRow